<template>
  <svg
    class="chevron-icon"
    :class="{ up: direction === 'up' }"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 9L12 15L18 9"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronIcon',
  props: {
    direction: {
      type: String,
      default: 'down'
    },
    height: {
      type: String,
      default: '15px'
    },
    width: {
      type: String,
      default: '15px'
    }
  }
}
</script>

<style lang="scss" scoped>
.chevron-icon {
  color: currentColor;
  transition: transform 0.2s ease;
}

.chevron-icon.up {
  transform: rotate(180deg);
}
</style>
